import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
    Text,
    Flex
} from "@chakra-ui/react";
import { InfoIconOutlineYellow } from "../../../styles/icons/InfoIconOutlineYellow";
import { useParams } from "react-router-dom";
import { showToast } from "../../../utils/toast";
import { useN8N } from "../../../hooks/useN8N";

export function ModalExcelCreditCard() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { id } = useParams();
    const { postExcelTransactionN8N } = useN8N();

    async function handleRequestExcel() {
        try {
            await postExcelTransactionN8N({idSeller: id});
            showToast({
                type: "success",
                message: "Relatório no excel enviado com sucesso, em breve você receberá um e-mail com o relatório."
            });
        } catch (error) {
            showToast({
                type: "error",
                message: "Erro ao enviar relatório no excel."
            });
        } finally {
            onClose();
        }
    }

    return (
        <>
            <Button
                size="sm"
                variant="outline"
                borderRadius="8px"
                color="black"
                fontSize="12px"
                fontWeight="400"
                p="8px 16px"
                onClick={onOpen}
                _hover={{
                    backgroundColor: "var(--Yellow-400, rgba(198, 138, 49, 1))",
                    color: "white"
                }}
            >
                Pedir relatório no excel
            </Button>

            <Modal 
                closeOnOverlayClick={false} 
                isOpen={isOpen} 
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent p="0" gap="8px" borderRadius="2px" alignSelf="center">
                    <Flex p="32px 32px 24px 32px" w="400" gap="16px" lineHeight="22px">
                        <Flex>
                            <InfoIconOutlineYellow size={24} />
                        </Flex>
                        <Flex flexDirection="column" gap="8px">
                            <ModalHeader p="0" fontSize="16px" fontWeight="600" color="rgba(0, 0, 0, 0.85)">
                                Pedir relatório no excel
                            </ModalHeader>
                            <ModalBody p="5px 0 " fontSize="14px" fontWeight="400" color="rgba(0, 0, 0, 0.85)">
                                <Text>
                                    Ao confirmar, o relatório no excel será enviado para o e-mail do usuário logado.
                                </Text>
                            </ModalBody>
                            <ModalFooter p="0">
                                <Flex gap="8px">
                                    <Button
                                        fontSize="14px"
                                        fontWeight="400"
                                        h="32px"
                                        onClick={onClose}
                                        variant="outline"
                                        w="89px"
                                        borderRadius="2px"
                                        color="black"
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        size="sm"
                                        variant="outline"
                                        borderRadius="8px"
                                        color="black"
                                        fontSize="12px"
                                        fontWeight="400"
                                        p="8px 16px"
                                        onClick={handleRequestExcel}
                                        _hover={{
                                            backgroundColor: "var(--Yellow-400, rgba(198, 138, 49, 1))",
                                            color: "white"
                                        }}
                                    >
                                        Gerar relatório
                                    </Button>
                                </Flex>
                            </ModalFooter>
                        </Flex>
                    </Flex>
                </ModalContent>
            </Modal>
        </>
    );
}
